module.exports = __webpack_public_path__ + "assets/images/popups/mobile_disclaimer_bg.png";